import React, { Component } from "react";
import { trans, setSpaceAfterNLetter, scrollTo } from "../../../helpers/index";
import config from "../../../baseConfig/index";
import Select from "react-select";
import ApiManager from "../../../apiManager/index";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import ErrorModal from "../../Fragments/ErrorModal";
import { Link } from "react-router-dom";
import { localStorageRemoveItem } from "../../../storage";

class Payment extends Component {
  constructor(props) {
    super(props);

    this.defaultState = {
      selectedOption: null,
      lastPayments: false,
      lastPaymentsData: "",
      rememberCard: false,
      number: this.props.parentState?.accountData?.data?.number?.includes("@") ? "" : this.props.parentState?.accountData?.data?.number
        ?.replace(/^\+374|^74/g, "")
        .trim(),
      checkNumber: "",
      checkNumberLength: 8,
      amount: "",
      cardList: "",
      msisdnType: "",
      payFormResponse: "",
      payButtonDisabled: false,
      successBox: false,
      failBox: false,
      showErrorModal: false,
      dontShowForm: false,
    };

    this.updateState = false;
    this.state = this.defaultState;
    this.componentIsMounted = true;
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.checkNumberSuccess = this.checkNumberSuccess.bind(this);
    this.cardListSuccess = this.cardListSuccess.bind(this);
    this.paySuccess = this.paySuccess.bind(this);
    this.getChequeSuccess = this.getChequeSuccess.bind(this);
    this.lastPaymentsSuccess = this.lastPaymentsSuccess.bind(this);
    this.errorCallBack = this.errorCallBack.bind(this);
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  componentWillMount() {
    this.initRequests();

    if (window.beelinePaymentResult) {
      this.setState({ dontShowForm: true });

      if (window.beelinePaymentResult.status === "payment_failed") {
        this.setState({
          payFormResponse: window.beelinePaymentResult,
          failBox: true,
        });
      } else if (window.beelinePaymentResult.status === "payment_success") {
        if (window.beelinePaymentResult.hasOwnProperty("opaque")) {
          this.getCheque();
        } else {
          this.setState({ successBox: true });
        }
      }
    }
  }

  getCheque() {
    ApiManager.postRequest(
      {
        opaque: window.beelinePaymentResult.opaque,
        _token: this.props.csrf_token.data,
        jwt: this.props.getDecryptedToken(),
      },
      "/payment/cheque"
    ).then(this.getChequeSuccess, this.errorCallBack);
  }

  getChequeSuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }

    this.setState({
      payFormResponse: resolve.data,
      successBox: resolve.data.status === "OK",
    });
  }

  lastPaymentsSuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }

    this.setState({
      lastPaymentsData: resolve.data,
    });
  }

  initRequests() {
    // Get payment card list
    ApiManager.getRequest(
      {
        jwt: this.props.getDecryptedToken(),
      },
      "/payment/card/list"
    ).then(this.cardListSuccess, this.errorCallBack);
    // }, '/payment/card/list').then(this.cardListSuccess, this.cardListSuccess);

    // Get payment card list
    ApiManager.getRequest(
      {
        jwt: this.props.getDecryptedToken(),
      },
      "/payment/recent"
    ).then(this.lastPaymentsSuccess, this.errorCallBack);

    // Check number balance
    this.checkNumberBalance();
  }

  checkNumberBalance() {
    if (this.state.number.length < this.state.checkNumberLength) {
      return;
    }

    // Check number
    ApiManager.postRequest(
      {
        jwt: this.props.getDecryptedToken(),
        _token: this.props.csrf_token.data,
        msisdn: this.state.number,
        amount: 100,
      },
      "/payment/check-number"
    ).then(this.checkNumberSuccess, this.errorCallBack);
    // }, '/payment/check-number').then( this.checkNumberSuccess, this.checkNumberSuccess );
  }

  cardListSuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }

    // @test
    // resolve.data = {"status":"OK","data":{"cards":[]}};
    // resolve.data = {"status":"OK","data":{"cards":[{"id":10011,"cardholder_name":"asdf","expiration_date":"03\/19","pan":"518180**2179"},{"id":10010,"cardholder_name":"TUTU TATA","expiration_date":"08\/20","pan":"518180**2179"},{"id":3,"cardholder_name":"TEst visa pos","expiration_date":"04\/15","pan":"518180**2179"},{"id":2,"cardholder_name":"asdfsd","expiration_date":"06\/20","pan":"518180**2179"},{"id":1,"cardholder_name":"Chihiro Inoue","expiration_date":"11\/19","pan":"518180**2179"}]}};

    if (resolve.data.status === "OK") {
      let data = [
        {
          value: null,
          label: trans(this.props.trans, "payment.select_default_label"),
        },
      ];

      resolve.data.data.cards.map((item) => {
        return data.push({
          value: item.id,
          label: item.pan,
        });
      });

      this.setState({
        cardList: data,
        selectedOption: data.length ? data[0] : null,
      });
    }
  }

  checkNumberSuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }

    // @test
    // resolve.data = { "status": "OK", "data": { "balance": -100, "balance_label": "-100 դրամ հաշվեկշիռ 2019.06.25" } };
    // resolve.data = { "status": "INVALID_DATA", "errors": { "msisdn": "Բաժանորդը չի գտնվել" } };

    this.setState({
      checkNumber: resolve.data,
      amount:
        resolve.data.status === "OK" && resolve.data.data.balance < 0
          ? resolve.data.data.balance * -1
          : "",
    });
    this.msisdnTypeSetter();
  }

  msisdnTypeSetter() {
    if (this.props.config !== "" && this.props.config.status === "OK") {
      let prefix = "",
        msisdnPfx = this.props.config.data.msisdn_pfx;

      for (let group in msisdnPfx) {
        let stop = false;

        for (let item in msisdnPfx[group]) {
          let prefixCurrent = msisdnPfx[group][item],
            pattern = new RegExp("^" + prefixCurrent);

          if (prefixCurrent.length > 1 && pattern.test(this.state.number)) {
            prefix = group;
            stop = true;
            break;
          }

          if (prefixCurrent.length === 1 && pattern.test(this.state.number)) {
            prefix = group;
          }
        }

        if (stop) {
          break;
        }
      }

      if (prefix !== "") {
        this.setState({
          msisdnType: prefix === "mobile" ? 0 : prefix === "fixed" ? 1 : 2,
        });
      }
    }
  }

  handleSelectChange(newState) {
    this.setState({
      selectedOption: newState,
    });
  }

  errorCallBack(reject) {
    this.setState({ showErrorModal: true });
  }

  paymentSelect(cardIdErrorClass, cardIdErrorBox) {
    if (this.state.cardList === "" || this.state.cardList.length === 1) {
      return "";
    }

    return (
      <div
        className={`form__form-box form__form-box--with-space${cardIdErrorClass}`}
      >
        <label
          className="form__label form__label--required db fs11"
          htmlFor="choose-card"
        >
          {trans(this.props.trans, "payment.form.card_label")}
        </label>
        <div className="form__field-out form__field-out--select-big pr">
          <Select
            options={this.state.cardList}
            value={this.state.selectedOption}
            onChange={this.handleSelectChange}
            placeholder={trans(
              this.props.trans,
              "payment.select_default_label"
            )}
            noOptionsMessage={() =>
              trans(this.props.trans, "payment.select_no_options_message")
            }
          />
        </div>
        {cardIdErrorBox}
        <div className="form__details-txt fs11">
          {trans(this.props.trans, "payment.form.card_note")}
        </div>
      </div>
    );
  }

  amountSetter(event) {
    let filteredAmount = event.target.value.trim().replace(/[^\d]/g, "");

    if (filteredAmount > 100000) {
      filteredAmount = 100000;
    }

    this.setState({ amount: filteredAmount });
  }

  pay(event) {
    event.preventDefault();

    this.setState({
      payButtonDisabled: true,
    });

    let sendData = {
      msisdn: this.state.number,
      amount: this.state.amount,
      save_card: this.state.rememberCard ? 1 : 0,
      _token: this.props.csrf_token.data,
      jwt: this.props.getDecryptedToken(),
    };

    if (this.state.selectedOption !== null) {
      sendData["card_id"] = this.state.selectedOption.value;
    }

    ApiManager.postRequest(sendData, "/payment/pay").then(
      this.paySuccess,
      this.errorCallBack
    );
    // ApiManager.postRequest(sendData, '/payment/pay').then( this.paySuccess, this.paySuccess );
  }

  paySuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }

    // @test

    // Success box example
    // resolve.data = {"status":"OK","data":{"message":"Ձեր գործարքը հաջողությամբ կատարված է","details":[{"label":"Հեռախոսահամար","value":"13153950"},{"label":"Վճարման ամսաթիվը","value":"2019-05-15 17:03:17"},{"label":"Գումար","value":"10 Dr"},{"label":"Պատվերի ID","value":"515261449"},{"label":"Վավերացման կոդ","value":"961659"},{"label":"Բանկային քարտ","value":"518180**2179"},{"label":"Անուն Ազգանուն Հայրանուն","value":"TUTU TATA"}]}};

    // Redirect url example
    // resolve.data = { "status": "OK", "data": { "redirect_url": "https://payments.ameriabank.am/forms/frm_paymentstype.aspx?clientid=34c38380-51ae-432c-994f-2de6fa5ca06e&clienturl=https%253A%252F%252Fstaging.beeline.am%252Fapi%252Fhy%252Fpayment%252Fdone%253Fjwt%253DeyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvc3RhZ2luZy5iZWVsaW5lLmFtXC9hcGlcLyIsImF1ZCI6Imh0dHBzOlwvXC9zdGFnaW5nLmJlZWxpbmUuYW1cL2FwaVwvIiwiaWF0IjoxNTYxNTUyMDE4LCJuYmYiOjE1NjE1NTIwMTgsImV4cCI6MTU2Mjg0ODAxOCwiaWQiOjEwLCJhY2NvdW50X2lkIjpudWxsfQ.cFSh4k5BSv8aKB8XRLiAAKTtfeUkg6LJBe-mt-J48OM&lang=am&paymentid=21987295-5473-4C3E-AB27-B71DCC938F9D" } };

    // resolve.data = { "status": "NOT_FOUND", "message": "Error here." };

    this.setState({
      payFormResponse: resolve.data,
      payButtonDisabled: false,
      successBox: resolve.data.status === "OK",
    });
  }

  formBox() {
    if (this.state.dontShowForm) {
      return;
    }

    let balance = "",
      msisdnIconList = [
        " form__field-out--with-mobile-icon",
        " form__field-out--with-fixed-icon",
        " form__field-out--with-internet-icon",
      ],
      msisdnIcon = "",
      buttonDisabled = true,
      checkNumberErrorClass = "",
      checkNumberErrorBox = "",
      msisdnErrorClass = "",
      msisdnErrorBox = "",
      amountErrorClass = "",
      amountErrorBox = "",
      saveCardErrorClass = "",
      saveCardErrorBox = "",
      cardIdErrorClass = "",
      cardIdErrorBox = "",
      errorBox = "";

    if (this.state.msisdnType !== "") {
      msisdnIcon = msisdnIconList[this.state.msisdnType];
    }

    if (
      this.state.msisdnType !== "" &&
      this.state.amount > 99 &&
      this.state.checkNumber !== "" &&
      this.state.checkNumber.status === "OK"
    ) {
      buttonDisabled = false;
    }

    if (this.state.checkNumber !== "") {
      if (this.state.checkNumber.status === "OK") {
        balance = (
          <div
            className={`form__details-txt form__details-txt--big${
              this.state.checkNumber.data.balance > -1
                ? " form__details-txt--green"
                : ""
            }`}
          >
            {this.state.checkNumber.data.balance_label}
          </div>
        );
      } else if (this.state.checkNumber.status === "ERROR") {
        checkNumberErrorClass = " form-error";
        checkNumberErrorBox = (
          <div className="form-error-text dn fs11">
            {this.state.checkNumber.message}
          </div>
        );
      } else if (this.state.checkNumber.status === "INVALID_DATA") {
        if (this.state.checkNumber.errors.hasOwnProperty("msisdn")) {
          checkNumberErrorClass = " form-error";
          checkNumberErrorBox = (
            <div className="form-error-text dn fs11">
              {this.state.checkNumber.errors.msisdn}
            </div>
          );
        }
      }
    }

    if (this.state.payFormResponse !== "") {
      if (this.state.payFormResponse.status === "INVALID_DATA") {
        if (this.state.payFormResponse.errors.hasOwnProperty("msisdn")) {
          msisdnErrorClass = " form-error";
          msisdnErrorBox = (
            <div className="form-error-text fs11">
              {this.state.payFormResponse.errors.msisdn}
            </div>
          );
        }

        if (this.state.payFormResponse.errors.hasOwnProperty("amount")) {
          amountErrorClass = " form-error";
          amountErrorBox = (
            <div className="form-error-text fs11">
              {this.state.payFormResponse.errors.amount}
            </div>
          );
        }

        if (this.state.payFormResponse.errors.hasOwnProperty("card_id")) {
          cardIdErrorClass = " form-error";
          cardIdErrorBox = (
            <div className="form-error-text form-error-text--top-space fs11">
              {this.state.payFormResponse.errors.card_id}
            </div>
          );
        }

        if (this.state.payFormResponse.errors.hasOwnProperty("save_card")) {
          saveCardErrorClass = " form-error";
          saveCardErrorBox = (
            <div className="form-error-text form-error-text--top-space fs11">
              {this.state.payFormResponse.errors.save_card}
            </div>
          );
        }
      }

      if (
        this.state.payFormResponse.status === "ERROR" ||
        this.state.payFormResponse.status === "NOT_FOUND"
      ) {
        errorBox = (
          <FormMiddlewareError message={this.state.payFormResponse.message} />
        );
      }
    }

    return (
      <div className="main-wrapper__double-list-item ver-top-box">
        <section className="main-wrapper__services main-wrapper__services--with-space">
          <h2 className="main-wrapper__sub-title main-wrapper__sub-title--card monserrat-medium pr sprite-b">
            {trans(this.props.trans, "payment.form.title")}
          </h2>

          <div className="form form--p24 form--bottom-radius form--relative">
            <form
              action="#"
              method="post"
              onSubmit={(event) => this.pay(event)}
            >
              <div className="form__form-box clear-fix">
                <div
                  // className={`${checkNumberErrorClass}${msisdnErrorClass}`}
                  className={`form__form-inner-big fl${checkNumberErrorClass}${msisdnErrorClass}`}
                >
                  <label className="form__label db fs11" htmlFor="tel-number">
                    {trans(this.props.trans, "payment.form.number_label")}
                  </label>
                  <div
                    className={`form__field-out form__field-out--with-prefix pr sprite-a${msisdnIcon}`}
                  >
                    <input
                      className="form__field fs13"
                      id="tel-number"
                      type="text"
                      name="tel-number"
                      value={this.state.number}
                      maxLength={this.state.checkNumberLength}
                      onChange={(event) =>
                        this.setState(
                          {
                            number: event.target.value
                              .trim()
                              .replace(/[^\d]/g, ""),
                            checkNumber: "",
                            msisdnType: "",
                          },
                          this.checkNumberBalance
                        )
                      }
                    />
                  </div>
                  {msisdnErrorBox}
                  {checkNumberErrorBox}
                  <div className="form__details-txt fs11">
                    {trans(this.props.trans, "payment.form.number_note")}
                  </div>
                </div>

                <div className="form__form-inner-small fr">
                  <label className="form__label db fs11" htmlFor="last-ones">
                    {trans(this.props.trans, "payment.form.last_label")}
                  </label>
                  <input
                    className="form__checkbox-last-ones dn"
                    type="checkbox"
                    id="last-ones"
                    name="last-ones"
                    checked={this.state.lastPayments}
                    onChange={() =>
                      this.setState({ lastPayments: !this.state.lastPayments })
                    }
                  />
                  <label
                    className="btn btn--yellow btn--with-history-icon sprite-b db full-width center-center-before pr"
                    htmlFor="last-ones"
                  >
                    {" "}
                  </label>
                </div>
              </div>

              <div
                className={`form__form-box form__form-box--with-space${amountErrorClass}`}
              >
                <label
                  className="form__label form__label--required db fs11"
                  htmlFor="price"
                >
                  {trans(this.props.trans, "payment.form.price_label")}
                </label>
                <div className="form__field-out pr">
                  <input
                    className="form__field fs13"
                    id="price"
                    type="text"
                    name="price"
                    value={this.state.amount}
                    onChange={(event) => this.amountSetter(event)}
                  />
                </div>
                {amountErrorBox}
                <div className="form__details-txt fs11">
                  {trans(this.props.trans, "payment.form.price_note")}
                </div>
                {balance}
              </div>

              {this.paymentSelect(cardIdErrorClass, cardIdErrorBox)}

              <div
                className={`form__form-box form__form-box--with-space${saveCardErrorClass}`}
              >
                <input
                  className="form__checkbox dn"
                  id="save-card"
                  name="save-card"
                  type="checkbox"
                  checked={this.state.rememberCard}
                  onChange={() =>
                    this.setState({ rememberCard: !this.state.rememberCard })
                  }
                />
                <label
                  className="form__check-label ver-top-box pr"
                  htmlFor="save-card"
                >
                  {" "}
                </label>
                <label
                  className="form__check-label-text ver-top-box fs15"
                  htmlFor="save-card"
                >
                  {trans(this.props.trans, "payment.form.remember_card_label")}
                </label>
                {saveCardErrorBox}
              </div>

              <div className="form__cards">
                <img
                  className="form__cards-img"
                  src={`${config.imgURLPrefix}img/cards.png`}
                  alt="Allowed cards"
                />
                <p className="form__cards-txt fs14">
                  {trans(this.props.trans, "payment.form.cards_note")}
                </p>
              </div>

              <ul className="list list--inner list--add">
                <li className="list__item pr">
                  <Link
                    className="list__link db sprite-b sprite-a pr monserrat-medium center-center-before"
                    onClick={() => localStorageRemoveItem("editAutoPaymentId")}
                    to={
                      config.urlPrefix +
                      this.props.parentState.urlPrefix +
                      "/addAutoPayment"
                    }
                  >
                    {trans(this.props.trans, "payment.form.autopayment_add")}
                  </Link>
                </li>
              </ul>

              {errorBox}

              <button
                className={`form__submit-btn btn btn--yellow fs17${
                  this.state.payButtonDisabled ? " btn--loading" : ""
                }`}
                type="submit"
                disabled={buttonDisabled || this.state.payButtonDisabled}
              >
                {trans(this.props.trans, "payment.form.pay_label")}
              </button>
            </form>
          </div>
        </section>
      </div>
    );
  }

  recentPaymentsBox() {
    if (!this.state.lastPayments) {
      return "";
    }

    let list = (
      <li className="list__item">
        <div className="list__link list__link--white-bg">
          <div className="list__inner-info--dark">
            {trans(this.props.trans, "payment.recent.empty_message")}
          </div>
        </div>
      </li>
    );

    if (
      this.state.lastPaymentsData !== "" &&
      this.state.lastPaymentsData.status === "OK" &&
      this.state.lastPaymentsData.data.recent_payments.length
    ) {
      list = this.state.lastPaymentsData.data.recent_payments.map(
        (item, index) => {
          return (
            <li className="list__item" key={index}>
              <div
                className={`list__link fb tl list__link--white-bg${
                  index === 0 ? " list__link--highlighted sprite-a pr" : ""
                }`}
              >
                +374 {setSpaceAfterNLetter(item.msisdn, 2)}
              </div>
            </li>
          );
        }
      );
    }

    if (
      this.state.lastPaymentsData !== "" &&
      this.state.lastPaymentsData.status === "ERROR"
    ) {
      list = (
        <li className="list__item">
          <p className="error-message">{this.state.lastPaymentsData.message}</p>
        </li>
      );
    }

    return (
      <div className="main-wrapper__double-list-item ver-top-box">
        <section className="main-wrapper__services">
          <h2 className="main-wrapper__sub-title main-wrapper__sub-title--history monserrat-medium pr sprite-b">
            {trans(this.props.trans, "payment.recent.title")}
          </h2>

          <div className="main-wrapper__list-out main-wrapper__list-out--small scroller-block">
            <ul className="list list--inclusions list--card-numbers">{list}</ul>
          </div>
        </section>
      </div>
    );
  }

  successBox() {
    let details = "",
      message = "";

    if (window.beelinePaymentResult && this.state.payFormResponse === "") {
      message = window.beelinePaymentResult.message;
    } else if (this.state.payFormResponse.data.hasOwnProperty("redirect_url")) {
      window.location = this.state.payFormResponse.data.redirect_url;
      return;
    } else if (this.state.payFormResponse.data.hasOwnProperty("details")) {
      message = this.state.payFormResponse.data.message;

      details = this.state.payFormResponse.data.details.map((item, index) => {
        return (
          <tr className="form__success-table-row" key={index}>
            <td className="form__success-table-cell fs14">{item.label}</td>
            <td className="form__success-table-cell">{item.value}</td>
          </tr>
        );
      });

      details = (
        <div className="form__table-out scroller-block">
          <table className="form__success-table full-width">
            <tbody>{details}</tbody>
          </table>
        </div>
      );
    }

    return (
      <div className="main-wrapper__double-list-item main-wrapper__double-list-item--big ver-top-box">
        <section className="main-wrapper__services">
          <h2 className="main-wrapper__sub-title main-wrapper__sub-title--card monserrat-medium pr sprite-b">
            {trans(this.props.trans, "payment.form.title")}
          </h2>
          <div className="form form--p24 form--bottom-radius form--relative">
            <div className="form__message form__message--success monserrat-medium sprite-b pr">
              {message}
            </div>
            {details}
            <button
              className="form__submit-btn btn btn--yellow fs17"
              type="submit"
              onClick={() => {
                this.setState(this.defaultState);
                this.initRequests();
              }}
            >
              {trans(this.props.trans, "payment.new.title")}
            </button>
          </div>
        </section>
      </div>
    );
  }

  failBox() {
    if (this.state.payFormResponse === "") {
      return "";
    }

    return (
      <div className="main-wrapper__double-list-item ver-top-box">
        <section className="main-wrapper__services">
          <h2 className="main-wrapper__sub-title main-wrapper__sub-title--card monserrat-medium pr sprite-b">
            {trans(this.props.trans, "payment.form.title")}
          </h2>
          <div className="form form--p24 form--bottom-radius form--relative">
            <div className="form__message form__message--error monserrat-medium sprite-b pr">
              {this.state.payFormResponse.message}
            </div>
            <button
              className="form__submit-btn btn btn--yellow fs17"
              type="submit"
              onClick={() => {
                this.setState(this.defaultState);
                this.initRequests();
              }}
            >
              {trans(this.props.trans, "payment.new.title")}
            </button>
          </div>
        </section>
      </div>
    );
  }

  recentPaymentsBoxScroller() {
    const winWidth = window.innerWidth || window.screen.availWidth;

    let scrollBox = null;

    if (winWidth < 1271 && winWidth > 1100) {
      scrollBox = document.querySelector(".main-wrapper__right-inner");
    } else if (winWidth < 1101) {
      scrollBox = document.querySelector("html");
    }

    if (scrollBox !== null) {
      setTimeout(() => {
        if (document.querySelector(".main-wrapper__sub-title--history")) {
          scrollTo(scrollBox, scrollBox.scrollHeight, 700);
          //scrollBox.scrollTop = scrollBox.scrollHeight;
        }
      }, 0);
    }
  }

  paymentForm() {
    if (this.state.successBox) {
      return this.successBox();
    }

    if (this.state.failBox) {
      return this.failBox();
    }

    return (
      <>
        {this.formBox()}
        {this.recentPaymentsBox()}
        {this.recentPaymentsBoxScroller()}
      </>
    );
  }

  errorModal() {
    if (!this.state.showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(this.props.trans, "error.modal.title")}
        description={trans(this.props.trans, "error.modal.description")}
        action_text={trans(this.props.trans, "error.modal.action_text")}
      />
    );
  }

  render() {
    if (!this.updateState && this.props.parentState.switchAccount) {
      this.defaultState.number = "";
      this.setState(this.defaultState);
      this.updateState = true;
    }

    if (
      this.updateState &&
      this.props.parentState.accountData !== "" &&
      this.props.parentState.accountData.status === "OK"
    ) {
      this.defaultState.number = this.props.parentState.accountData.data.number
        .replace(/^\+374|^74/g, "")
        .trim();
      this.setState(this.defaultState, this.initRequests);
      this.updateState = false;
    }

    return (
      <div className="main-wrapper__double-list main-wrapper__double-list--max-976">
        {this.paymentForm()}
        {this.errorModal()}
      </div>
    );
  }
}

export default Payment;
